import React, { useEffect, useRef, useState } from 'react';
import { JspreadLicense, localizeCategory } from 'utils/constant';
import { message, Space } from 'antd';
import { useCookies } from 'react-cookie';
import jspreadsheet from 'jspreadsheet-pro';
import { localizingApi } from 'apis/common/localizingApis';
import TableToolbar from 'components/table/TableToolbar';
import RegisterButton from 'components/button/RegisterButton';
import Select from 'components/select/Select';
import styled from 'styled-components';
import LoadingPage from 'pages/LoadingPage';
import { useTranslation } from 'react-i18next';
import DefaultLayout from 'components/layout/DefaultLayout';
import SearchInput from 'components/search/SearchInput';

/**
 * * 다국어 설정
 */
let currentExcel = null; // 초기 엑셀 테이블
const LocalizingTablePage = () => {
  const { t } = useTranslation();
  const [{ managementAuth = 'false' }] = useCookies([]);
  const authUpdate = JSON.parse(managementAuth);
  const jspreadsheetRef = useRef();
  const [categoryId, setCategoryId] = useState('all');
  const [isLoading, setIsLoading] = useState(false);
  const [searchData, setSearchData] = useState();

  /// 드롭다운 이벤트
  const handleSelectChange = (value) => {
    setCategoryId(value);
  };

  /// 추가된 행 이외의 id는 readonly 처리
  const processReadOnly = (worksheet, cell, x, y, source, value, label) => {
    if (!currentExcel) return;
    if (x !== 0) return;

    // stat이 I가 아니면 readonly 속성 부여

    if (currentExcel.getValueFromCoords(13, y) !== 'I') {
      cell.classList.add('readonly');
    } else {
      // insertRow를 할때, 바로 위 행의 속성(?)같이 가져오는 것 같다.

      // 그래서 'I' 일때 빼준다.
      // console.log('this is I', x, y);
      // console.log(cell.classList);
      cell.classList.remove('readonly'); // 빼주자!
    }
  };
  /// 수정된 데이터는 stat에 'U' 삽입하기
  const handlestatchange = (worksheet, cell, x, y, newValue, oldValue) => {
    if (x === 8) return; // x 값을 리턴해야지 무한 루프를 안탄다.
    if (oldValue === newValue) return;
    if (currentExcel.options.json[y]['stat'] !== 'I') {
      currentExcel.setValueFromCoords(13, y, 'U', true);
    }
  };

  /// 행 추가
  const handleAddRow = () => {
    currentExcel.insertRow();
    // console.log(jspreadsheetRef.current.jspreadsheet);
    // jspreadsheetRef.current.jspreadsheet.insertRow();
    let rowNum = currentExcel.options.data.length;
    // 추가된 행의 '상태'에 'I' 입력
    currentExcel.setValueFromCoords(13, rowNum - 1, 'I', true);
    currentExcel.setValueFromCoords(1, rowNum - 1, categoryId, true);
  };

  /// 서버 저장
  const handleSubmit = async () => {
    return message.info('구현중입니다.');

    let dataJson = currentExcel.options.json;
    let dataJsonArrFilter = []; // id가 공백인 것을 삭제한 배열
    // console.log(dataJson);

    dataJson.forEach((v) => {
      // stat이 I, U가 있는 것만 보내고 싶다.
      if (v.stat.indexOf('I') !== -1 || v.stat.indexOf('U') !== -1) {
        // id 값이 공백일 경우, 삭제될 것
        if (v.text_id !== '') {
          dataJsonArrFilter.push(v);
        }
      }
    });

    if (dataJsonArrFilter.length < 1) {
      alert('아이디가 입력되지 않을 경우, 저장되지 않습니다.');
      return;
    }
    // const res = await localizingApi.update(dataJsonArrFilter);
    // console.log(res);
    if (!res) {
      return false;
    }
    message.success('서버에 저장되었습니다', 1);
  };

  /// 데이터 불러오기
  const fetchData = async (excel) => {
    setIsLoading(true);
    currentExcel = jspreadsheet(jspreadsheetRef.current, jspreadOption);

    const res = await localizingApi.read();

    if (res?.length === 0) {
      currentExcel.setData([[]]);
    }
    currentExcel.setData(res);

    //* 탭 지우기
    /*
      카테고리를 변경할 때 마다 워크시트가 늘어남. 아마도 라이브러리의 버그로 생각됨.
      카테고리를 변경할 때, 데이터를 불러오고, 스프레드 시트에 변화가 일어나는 것을 찾음.
      최초에 로딩될때는 Sheet 1 이란 이름으로 렌더링, 그 이후엔 Sheet 2, Sheet 3 ...
      이런 식의 이름이 붙음
      그래서 Sheet 1 이 아닐 경우, 맨 앞에 있는 워크시트를 삭제하게 만듦.
 */
    if (
      // categoryId !== '%' ||
      currentExcel.options.worksheetName !== 'Sheet 1'
    ) {
      currentExcel.deleteWorksheet(0);
    }
    setIsLoading(false);
  };

  const jspreadOption = {
    license: JspreadLicense,
    data: [[]],
    columns: [
      {
        type: 'number',
        name: 'text_id',
        title: 'ID',
        width: '80px',
        // readOnly: true,
      },
      {
        type: 'text',
        name: 'category',
        title: t('multilang.table.category'),
        width: '80px',
        readOnly: true,
      },
      {
        type: 'text',
        name: 'KO',
        title: t('multilang.table.korean'),
        width: '200px',
        // readOnly: master_auth === 0,
      },
      {
        type: 'text',
        name: 'EN',
        title: t('multilang.table.english'),
        width: '200px',
        // readOnly: master_auth === 0,
      },
      {
        type: 'text',
        name: 'JA',
        title: t('multilang.table.japanese'),
        width: '200px',
        // readOnly: master_auth === 0,
      },
      {
        type: 'text',
        name: 'AR',
        title: t('multilang.table.arabic'),
        width: '200px',
        // readOnly: master_auth === 0,
      },
      {
        type: 'text',
        name: 'MS',
        title: t('multilang.table.malay'),
        width: '200px',
        // readOnly: master_auth === 0,
      },
      {
        type: 'text',
        name: 'ES',
        title: t('multilang.table.spanish'),
        width: '200px',
        // readOnly: master_auth === 0,
      },
      {
        type: 'text',
        name: 'RU',
        title: t('multilang.table.russian'),
        width: '200px',
        // readOnly: master_auth === 0,
      },
      {
        type: 'text',
        name: 'ID',
        title: t('multilang.table.indonesian'),
        width: '200px',
        // readOnly: master_auth === 0,
      },
      {
        type: 'text',
        name: 'memo',
        title: t('multilang.table.memo'),
        width: '100px',
        // readOnly: master_auth === 0,
      },
      {
        type: 'hidden',
        name: 'SC',
        title: t('multilang.table.simplifiedChinese'),
        width: '150px',
        // readOnly: master_auth === 0,
      },
      {
        type: 'hidden',
        name: 'ZH',
        title: t('multilang.table.traditionalChinese'),
        width: '150px',
        // readOnly: master_auth === 0,
      },
      {
        type: 'hidden',
        name: 'stat',
        title: t('multilang.table.status'),
        width: '130px',
      },
    ],
    text: {
      areYouSureToDeleteTheSelectedRows: t('multilang.table.deleteRowMessage'),
      areYouSureToDeleteTheSelectedColumns: t(
        'multilang.table.deleteRowMessage',
      ),
    },
    allowExport: false,
    tableOverflow: true,
    tableHeight: '50rem',
    updateTable: processReadOnly,
    contextMenu: function (obj, x, y, e) {
      // 마우스 우클릭 금지
      return;
    },
    onbeforedeletecolumn: function (el, columnNumber, numOfColumns) {
      return false;
    },
    onbeforedeleterow: function (el, rowNumber, numOfRows) {
      return false;
    },
    onselection: function (el, px, py, ux, uy, origin) {
      // setSelectRow(py);
    },
    onchange: handlestatchange,
  };
  useEffect(() => {
    // currentExcel = jspreadsheet(jspreadsheetRef.current, jspreadOption);
    fetchData(currentExcel);
  }, [categoryId]);
  return (
    <DefaultLayout>
      <Container>
        <LoadingPage isLoading={isLoading} />
        <TableToolbar style={{ marginBottom: '0.5rem' }}>
          <Space>
            <Select
              // title="프로젝트"
              showAllOption={true}
              name='project_id'
              value={categoryId}
              optionList={localizeCategory}
              onChange={handleSelectChange}
              style={{ width: '10rem' }}
              placeholder={'카테고리 선택'}
            />
            <SearchInput
              placeholder={'검색할 텍스트를 입력하세요.'}
              setSearchData={setSearchData}
            />
          </Space>
          <div>
            <RegisterButton onClick={handleAddRow} disabled={authUpdate}>
              {t('multilang.header.addRow')}
            </RegisterButton>
            <RegisterButton onClick={handleSubmit} disabled={authUpdate}>
              {t('multilang.header.saveToServer')}
            </RegisterButton>
          </div>
        </TableToolbar>
        <div ref={jspreadsheetRef} className='tableColor' />
      </Container>
    </DefaultLayout>
  );
};
export default LocalizingTablePage;

const Container = styled.div`
  overflow-x: auto;
  overflow-y: auto;
  /* max-width: 100%;
  width: 100%; */
  /* max-height: 77vh; */
`;
